<template>
  <div class="card">
    <div class="card-content">
      <div class="has-text-centered">
        <img :src="notebook" />
      </div>
      <slot></slot>
      <b-tabs v-model="activeTab">
        <b-tab-item>
          <social-login-container
            :line="line"
            :is-sign-up="false"
            :handle-switch-tab="handleSwitchTab"></social-login-container>
        </b-tab-item>
        <b-tab-item>
          <social-login-container
            :line="line"
            :is-sign-up="true"
            :handle-switch-tab="handleSwitchTab"></social-login-container>
        </b-tab-item>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import notebook from '@/assets/notebook.png'
import SocialLoginContainer from './SocialLoginContainer.vue'

export default {
  name: 'LoginSignupTabs',
  components: {
    SocialLoginContainer
  },
  props: {
    startingTab: {
      default: 0,
      type: Number
    },
    line: {
      type: Object
    }
  },
  data() {
    return {
      activeTab: this.startingTab,
      notebook
    }
  },
  methods: {
    handleSwitchTab(toSignUp) {
      if (toSignUp) {
        this.activeTab = 1
      } else {
        this.activeTab = 0
      }
    }
  }
}
</script>

<style scoped lang="scss">
.card {
  border-radius: 4px;
  width: 100%;

  img {
    background-color: #e1dcf5;
    border-color: #7957d5;
    border-radius: 200px;
    border-style: solid;
    border-width: 2px;
    height: 50px;
    margin-top: -70px;
    padding: 5px;
  }

  @media only screen and (min-device-width : 768px) {
    min-width: 550px;

    img {
      border-width: 5px;
      height: 100px;
      padding: 10px;
    }
  }
}

</style>
